
import { Component, Vue } from 'vue-property-decorator';
import { ScrollShadow } from '@warrenbrasil/nebraska-web';

@Component({
  components: { ScrollShadow }
})
export default class FullHeightPanel extends Vue {}
